var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplosion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1659 4.83333L14.2434 3.75583C14.4302 3.56903 14.5784 3.34725 14.6795 3.10318C14.7806 2.85911 14.8326 2.59751 14.8326 2.33333C14.8326 2.11232 14.9204 1.90036 15.0766 1.74408C15.2329 1.5878 15.4449 1.5 15.6659 1.5H16.4992M4.83257 9.83333C4.83257 9.17029 5.09596 8.53441 5.5648 8.06557C6.03364 7.59672 6.66953 7.33333 7.33257 7.33333M14.5409 6.20834C14.6339 6.30121 14.7076 6.4115 14.758 6.5329C14.8083 6.6543 14.8342 6.78442 14.8342 6.91584C14.8342 7.04725 14.8083 7.17738 14.758 7.29878C14.7076 7.42018 14.6339 7.53047 14.5409 7.62334L13.7309 8.43334C14.1354 9.76669 14.0827 11.197 13.5812 12.4969C13.0797 13.7969 12.1582 14.8921 10.9631 15.6084C9.76801 16.3247 8.3678 16.6211 6.98493 16.4506C5.60206 16.28 4.31584 15.6522 3.33059 14.667C2.34535 13.6817 1.71758 12.3955 1.54701 11.0126C1.37645 9.62978 1.67287 8.22957 2.38919 7.03445C3.10551 5.83933 4.20065 4.91784 5.50063 4.41638C6.80061 3.91491 8.23088 3.86222 9.56424 4.26667L10.3742 3.45667C10.4671 3.3637 10.5774 3.28994 10.6988 3.23961C10.8202 3.18929 10.9503 3.16339 11.0817 3.16339C11.2132 3.16339 11.3433 3.18929 11.4647 3.23961C11.5861 3.28994 11.6964 3.3637 11.7892 3.45667L14.5409 6.20834Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosion);
export default __webpack_public_path__ + "static/media/Explosion.49263305a6cf7c1b6b289b4b2981323c.svg";
export { ForwardRef as ReactComponent };